import { Stack } from '@mui/material';
import HoursAlert from '../../hours-alert/hours-alert.component';
import TemporaryHoursCalendar from 'components/location-hours/temporary-hours-calendar/temporary-hours-calendar.component';

const TemporaryHours = () => {
  return (
    <Stack direction="column" gap={2} mt={2}>
      <HoursAlert />
      <TemporaryHoursCalendar />
    </Stack>
  );
};

export default TemporaryHours;
